import { render } from "./ChangePwView.vue?vue&type=template&id=1d42a429&class=fondogob"
import script from "./ChangePwView.vue?vue&type=script&lang=js"
export * from "./ChangePwView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__